import type { PageService } from '../services/pageService'
import type { Page, PageInput, ListPagesParams } from '../types'
import { wireApiClient as client } from './wireApiClient'

export const httpPageService: PageService = {
  async list(params?: ListPagesParams) {
    const { data } = await client.get<Page[]>('/pages', { params })
    return data
  },

  async get(id: string) {
    const { data } = await client.get<Page>(`/pages/${id}`)
    return data
  },

  async getLive() {
    const { data } = await client.get<Page>('/pages/live')
    return data
  },

  async getLiveByKindSlug(kind: string, slug: string) {
    const { data } = await client.get<Page>(`/pages/live/${encodeURIComponent(kind)}/${encodeURIComponent(slug)}`)
    return data
  },

  async getLiveEditions() {
    const { data } = await client.get<Page[]>('/pages/live/editions')
    return data
  },

  async create(input: PageInput) {
    const { data } = await client.post<Page>('/pages', input)
    return data
  },

  async update(id: string, input: PageInput) {
    const { data } = await client.put<Page>(`/pages/${id}`, input)
    return data
  },

  async publish(id: string) {
    const { data } = await client.put<Page>(`/pages/${id}/publish`)
    return data
  },

  async schedule(id: string, scheduledFor: string) {
    const { data } = await client.put<Page>(`/pages/${id}/schedule`, { scheduledFor })
    return data
  },

  async archive(id: string) {
    const { data } = await client.put<Page>(`/pages/${id}/archive`)
    return data
  },

  async delete(id: string) {
    await client.delete(`/pages/${id}`)
  },
}
